import React from 'react'
import { Modal } from '../../../map-editor-shared/ui/Modal'
import styles from '../EditorPage.module.css'

interface SaveModalProps {
  isOpen: boolean
  onClose: () => void
  autoNavigate: boolean
  saveCountdown: number
  onConfirm: () => void
}

/**
 * SaveModal - 저장 완료 모달
 *
 * 맵 데이터와 썸네일 저장 성공 시 표시되는 모달
 * - 성공 애니메이션과 아이콘 표시
 * - 자동 네비게이션 옵션 지원
 * - 카운트다운 표시
 */
export const SaveModal: React.FC<SaveModalProps> = ({
  isOpen,
  onClose,
  autoNavigate,
  saveCountdown,
  onConfirm
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        onClose()
      }}
      title="저장 완료"
    >
      <div style={{
        padding: '40px 20px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '24px'
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          background: 'linear-gradient(135deg, #10b981, #059669)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          animation: 'successPulse 0.6s ease-out',
          boxShadow: '0 8px 24px rgba(16, 185, 129, 0.3)'
        }}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>
        <div>
          <h3 style={{
            margin: '0 0 8px 0',
            fontSize: '20px',
            fontWeight: '600',
            color: 'var(--color-text)'
          }}>
            저장되었습니다!
          </h3>
          <p style={{
            margin: 0,
            fontSize: '14px',
            color: 'var(--color-text-secondary)',
            lineHeight: '1.6'
          }}>
            맵 데이터와 썸네일이 성공적으로 저장되었습니다.
          </p>
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '12px',
          width: '100%'
        }}>
          <button
            className={styles.primaryButton}
            onClick={autoNavigate ? onConfirm : onClose}
            style={{
              minWidth: '200px',
              padding: '12px 32px',
              background: 'linear-gradient(135deg, #3b82f6, #60a5fa)',
              border: 'none',
              borderRadius: '8px',
              color: 'white',
              fontSize: '14px',
              fontWeight: '600',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)'
              e.currentTarget.style.boxShadow = '0 6px 16px rgba(59, 130, 246, 0.4)'
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)'
              e.currentTarget.style.boxShadow = '0 4px 12px rgba(59, 130, 246, 0.3)'
            }}
          >
            {autoNavigate ? '대시보드로 이동' : '확인'}
          </button>
          {autoNavigate && (
            <p style={{
              margin: 0,
              fontSize: '12px',
              color: 'var(--color-text-tertiary)'
            }}>
              {saveCountdown}초 후 자동으로 이동합니다
            </p>
          )}
        </div>
      </div>
    </Modal>
  )
}
